export const UserRolesKeysEnum = {
  ADMIN: "admin",
  MEMBER: "member",
  HR: "hr"
}
